/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, CardActions, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import './ShareEventButton.css';
import LinkSVG from './linkSVG';

function ShareEventButton({ onClick }) {
  return (
    <div className="share-event-button">
      <LinkSVG className="link-svg" />
      <Button size="small" className="action-button" onClick={onClick}>
        Share Event
      </Button>
    </div>
  );
}

export default ShareEventButton;
